export default function shouldSync ( expiredAccounts?:BankAccount[], bankAccounts?:BankAccount[]){
    if(!bankAccounts?.length) return false;
    if(expiredAccounts?.length === 0 || expiredAccounts?.length && bankAccounts?.length > expiredAccounts.length) return true
}
